export const track = (props, options, cb) => {
  if (window && window.freshpaint) {
    window.freshpaint.track(props.event, { ...props.data }, options, cb);
  }
};

export default track;
